import React, { useState, useEffect } from "react";
import {
  Container,
  Card,
  Row,
  Col,
  Image,
  Spinner,
  Button,
  Nav,
  Badge,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import AuthNavBar from "./components/nav/AuthNav";
import axios from "axios";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ViewDetails = () => {
  const { t } = useTranslation();
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const token = localStorage.getItem("token");
  const trackingID = localStorage.getItem("trackingIDFromServer");

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await axios.get(
          `https://idms-preenrol.e-citizen.org/api/v1/enrolment/trackingId/${trackingID}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        );
        setUserData(response.data);
        setLoading(false);
      } catch (err) {
        setError(t("failed_fetch_user_data"));
        setLoading(false);
      }
    };

    fetchUserData();
  }, [token, trackingID]);

  const renderContent = () => {
    if (loading) {
      return (
        <Container
          className="d-flex justify-content-center align-items-center"
          style={{ height: "calc(100vh - 56px)" }} // Adjust for navbar height
        >
          <Spinner animation="border" role="status">
            <span className="visually-hidden">{t("loading")}</span>
          </Spinner>
        </Container>
      );
    }

    if (error) {
      return <h4 className="text-center text-danger mt-5">{error}</h4>;
    }

    if (!userData) {
      return (
        <h4 className="text-center text-warning mt-5">{t("no_user_data")}</h4>
      );
    }

    return (
      <Container className="mt-4">
        <h2 className="mb-4 text-center fw-bold">{t("enrolment_details")}</h2>
        <Row className="justify-content-center">
          <Col md={4}>
            <Card className="shadow-lg rounded-4 border-0">
              <Card.Body className="text-center">
                <Image
                  src={`data:image/jpeg;base64,${userData.photo}`}
                  roundedCircle
                  width={130}
                  height={130}
                  className="border border-3"
                  style={{ borderColor: "#157347" }}
                />
                <h4 className="mt-3 fw-bold text-dark">{`${userData.firstName} ${userData.lastName}`}</h4>
                <p className="text-muted">
                  {" "}
                  <strong>{t("nui")}:</strong>
                  {userData.nui}
                </p>
                <Badge
                  bg={
                    userData.status === "PRE-ENROL"
                      ? "warning"
                      : userData.status === "APPROVED"
                        ? "success"
                        : "secondary"
                  }
                  className="px-3 py-2 fs-6"
                >
                  {userData.status}
                </Badge>
                <div className="mt-3">
                  {userData.status === "PRE-ENROL" && (
                    <Nav.Link
                      as={Link}
                      to={{
                        pathname: "/personal-modification",
                        state: { userData },
                      }}
                    >
                      <Button variant="success" className="px-4 py-2 shadow-sm">{t("edit_details")}</Button>
                    </Nav.Link>
                  )}
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col md={8}>
            <Card className="shadow-lg rounded-4 border-0">
              <Card.Body>
                <h4 className="fw-bold text-dark border-bottom pb-2">{t("personal_details")}</h4>
                <Row>
                  <Col md={6}>
                    <p>
                      <strong className="text-muted">{t("first_name")}:</strong>{" "}
                      {userData.firstName}
                    </p>
                    <p>
                      <strong className="text-muted">{t("phone_number")}:</strong>{" "}
                      {userData.phoneNumber}
                    </p>
                    <p>
                      <strong className="text-muted">{t("region")}:</strong>{" "}
                      {userData.region}
                    </p>
                    <p>
                      <strong className="text-muted">{t("district")}:</strong>{" "}
                      {userData.district}
                    </p>
                    <p>
                      <strong className="text-muted">{t("address")}:</strong>{" "}
                      {userData.residenceAddress}
                    </p>
                    <p>
                      <strong className="text-muted">{t("maiden_name")}:</strong>{" "}
                      {userData.maidenName}
                    </p>
                  </Col>
                  <Col md={6}>
                    <p>
                      <strong className="text-muted">{t("last_name")}:</strong>{" "}
                      {userData.lastName}
                    </p>
                    <p>
                      <strong className="text-muted">{t("email_address")}:</strong>{" "}
                      {userData.email}
                    </p>
                    <p>
                      <strong className="text-muted">{t("province")}:</strong>{" "}
                      {userData.province}
                    </p>
                    <p>
                      <strong className="text-muted">{t("central_record_id")}:</strong>{" "}
                      {userData.centralRecordId}
                    </p>
                    <p>
                      <strong className="text-muted">{t("contact_owner")}:</strong>{" "}
                      {userData.contactOwner}
                    </p>
                    <p>
                      <strong className="text-muted">{t("place_of_birth")}:</strong>{" "}
                      {userData.placeOfBirth || "Not provided"}
                    </p>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  };

  return (
    <>
      <AuthNavBar />
      {renderContent()}
    </>
  );
};

export default ViewDetails;
